import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { InterviewerProvider } from './context/InterviewerContext';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import CreateInterviewer from './components/CreateInterviewer';
import EditInterviewer from './components/EditInterviewer';
import Settings from './components/Settings';
import Interview from './components/Interview';
import NotFound from './components/NotFound';

function App() {
  return (
    <InterviewerProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/interview/:id" element={<Interview />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <main className="container mx-auto px-4 py-8">
                    <Dashboard />
                  </main>
                </ProtectedRoute>
              }
            />
            <Route
              path="/create"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <main className="container mx-auto px-4 py-8">
                    <CreateInterviewer />
                  </main>
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit/:id"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <main className="container mx-auto px-4 py-8">
                    <EditInterviewer />
                  </main>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <main className="container mx-auto px-4 py-8">
                    <Settings />
                  </main>
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </Router>
    </InterviewerProvider>
  );
}

export default App;